module.exports = __webpack_public_path__ + "img/allergy_status.b2665023.svg";